var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image__wrapper",class:{rounded:_vm.rounded}},[_c('image-spinner'),_c('img',{staticClass:"image__item",attrs:{"data-url":_vm.src,"alt":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }